import { axios } from "../utils/axios";
import { toast } from "react-toastify";
import { toastOptions } from "../config/toast";
import { useGeneralAppStore } from "../store/generalAppStore";
import { isAxiosError } from "axios";

const { handlerLoading } = useGeneralAppStore.getState();

//^TRAE TODO LOS BARRIOS
export const cargaBarrios = async () => {
  handlerLoading({ loading: true, loadName: "carga_barrios" });
  try {
    const response = await axios().get("barrios");
    if (!isAxiosError(response)) {
      const { data, error } = response.data;
      if (error) toast.error(error, toastOptions);
      return data;
    }
  } catch (error) {
    toast.error("Hubo un error en la consulta", toastOptions);
  } finally {
    handlerLoading({ loading: false, loadName: "carga_barrios" });
  }
};

//^TRAE TODO LOS BARRIOS
export const cargaTipos = async () => {
  handlerLoading({ loading: true, loadName: "carga_tipos" });
  try {
    const response = await axios().get("tipo");
    if (!isAxiosError(response)) {
      const { data, error } = response.data;
      if (error) toast.error(error, toastOptions);
      return data;
    }
  } catch (error) {
    toast.error("Hubo un error en la consulta", toastOptions);
  } finally {
    handlerLoading({ loading: false, loadName: "carga_tipos" });
  }
};
